import { render, staticRenderFns } from "./Take.vue?vue&type=template&id=7b4fd29e&"
import script from "./Take.vue?vue&type=script&lang=js&"
export * from "./Take.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports